import { motion } from "framer-motion";
import { director } from "../data/site";

export default function DirectorMessage() {
    return (
        <section
            id="director"
            className="relative bg-[#0b0b0b] py-24 md:py-40 px-6 md:px-10"
            data-testid="director-section"
        >
            <div className="mx-auto max-w-[1440px]">
                <div className="flex items-center gap-6 mb-10">
                    <span className="w-16 h-px bg-[#C89B3C]" />
                    <span className="text-[10px] uppercase tracking-[0.4em] text-[#C89B3C]">
                        Chapter 15 — From the Desk
                    </span>
                </div>

                <div className="grid grid-cols-12 gap-6 md:gap-10 items-center">
                    <motion.figure
                        initial={{ opacity: 0, scale: 1.05 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 1.2, ease: [0.2, 0.7, 0.2, 1] }}
                        className="col-span-12 md:col-span-5 relative"
                    >
                        <div className="relative aspect-[4/5] overflow-hidden">
                            <img
                                src={director.img}
                                alt={director.name}
                                className="w-full h-full object-cover transition-transform duration-[1500ms] hover:scale-105"
                            />
                            <div className="absolute inset-0 border border-[rgba(212,175,55,0.35)]" />
                        </div>
                        {/* Pinned corner tag — sits outside the image mask */}
                        <motion.div
                            initial={{ opacity: 0, y: -8, rotate: -6 }}
                            whileInView={{ opacity: 1, y: 0, rotate: -4 }}
                            viewport={{ once: true, margin: "-15%" }}
                            transition={{ duration: 0.8, delay: 0.4 }}
                            className="absolute top-6 left-6 md:top-8 md:left-8 z-20 bg-[#C89B3C] text-[#0b0b0b] px-4 py-2 text-[10px] uppercase tracking-[0.35em] font-medium shadow-[0_18px_40px_-12px_rgba(0,0,0,0.7)]"
                            data-testid="director-note-badge"
                        >
                            <span className="flex items-center gap-2">
                                <span className="w-1.5 h-1.5 rounded-full bg-[#0b0b0b]" />
                                Director&apos;s Note
                            </span>
                        </motion.div>
                    </motion.figure>

                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-15%" }}
                        transition={{ duration: 0.9 }}
                        className="col-span-12 md:col-span-7 md:pl-6 lg:pl-14"
                    >
                        <div className="font-display text-6xl md:text-7xl text-[#C89B3C]/80 leading-none">
                            “
                        </div>
                        <blockquote className="mt-4 font-display font-light text-white text-3xl md:text-4xl lg:text-5xl leading-[1.1] tracking-tight">
                            Every project we undertake is built with the same commitment to{" "}
                            <em className="text-[#E2C56D]">quality, trust and integrity</em>{" "}
                            that our founder envisioned over four decades ago.
                        </blockquote>

                        {/* Signature */}
                        <div className="mt-14 flex items-end gap-6">
                            <svg
                                viewBox="0 0 320 80"
                                className="w-52 md:w-64 h-16"
                                aria-hidden
                            >
                                <motion.path
                                    initial={{ pathLength: 0 }}
                                    whileInView={{ pathLength: 1 }}
                                    viewport={{ once: true, margin: "-15%" }}
                                    transition={{ duration: 2.2, ease: [0.2, 0.7, 0.2, 1] }}
                                    d="M10 55 C 40 20, 60 65, 90 40 S 140 15, 170 45 S 220 70, 250 30 C 270 10, 295 40, 310 55"
                                    stroke="#E2C56D"
                                    strokeWidth="1.6"
                                    fill="none"
                                    strokeLinecap="round"
                                />
                            </svg>
                            <div className="pb-2 border-l border-[rgba(212,175,55,0.35)] pl-6">
                                <div className="font-display text-xl text-white">
                                    {director.name}
                                </div>
                                <div className="text-[11px] uppercase tracking-[0.3em] text-[#bebebe] mt-1">
                                    {director.role}
                                </div>
                            </div>
                        </div>
                    </motion.div>
                </div>
            </div>
        </section>
    );
}
